import {
    CREATE_SEASON_MASTER_FAILURE,
    CREATE_SEASON_MASTER_REQUEST,
    CREATE_SEASON_MASTER_SUCCESS,
    CREATE_USER_FORM_SEASON_MASTER,
    FETCH_SEASON_MASTER_FAILURE,
    FETCH_SEASON_MASTER_REQUEST,
    FETCH_SEASON_MASTER_SUCCESS,
    FETCH_SINGLE_SEASON_MASTER_FAILURE,
    FETCH_SINGLE_SEASON_MASTER_REQUEST,
    FETCH_SINGLE_SEASON_MASTER_SUCCESS,
    SEASON_MASTER_USERFORM_RESET,
    UPDATE_SEASON_MASTER_REQUEST,
    UPDATE_SEASON_MASTER_SUCCESS,
    UPDATE_SEASON_MASTER_FAILURE,
    DELETE_SEASON_MASTER_REQUEST,
    DELETE_SEASON_MASTER_SUCCESS,
    DELETE_SEASON_MASTER_FAILURE
} from './seasonMaster.actionsType';

export const SEASON_MASTER = 'seasonMaster';

let initialState = {
    loading: false,
    seasonMaster: [],
    seasonMasterForm: {},

    selectedSeason: {},
    errorMessage: '',
    iperrorMessage: ''
};

export let seasonMasterReducer = (state = initialState, action) => {
    let { type, updatePayload, payload } = action;

    switch (type) {
        case FETCH_SEASON_MASTER_REQUEST:
        case CREATE_SEASON_MASTER_REQUEST:
        case FETCH_SINGLE_SEASON_MASTER_REQUEST:
        case UPDATE_SEASON_MASTER_REQUEST:
        case DELETE_SEASON_MASTER_REQUEST:
            return {
                ...state,
                loading: true
            };

        case FETCH_SEASON_MASTER_SUCCESS:
            return {
                ...state,
                loading: false,
                seasonMaster: updatePayload
            };

        case CREATE_SEASON_MASTER_SUCCESS:
            return {
                ...state,
                loading: false,
                seasonMasterForm: {}
            };
        case FETCH_SINGLE_SEASON_MASTER_SUCCESS:
            return {
                ...state,
                selectedSeason: updatePayload,
                loading: false,
                seasonMasterForm: {
                    ...updatePayload,
                    fldSeasonFrom: updatePayload.fldSeasonFrom.split('T')[0],
                    fldSeasonTo: updatePayload.fldSeasonTo.split('T')[0]
                }
            };
        case UPDATE_SEASON_MASTER_SUCCESS:
            return {
                ...state,
                loading: false,
                seasonMasterForm: {},
                selectedSeason: {}
            };
        case DELETE_SEASON_MASTER_SUCCESS:
            return {
                ...state,
                loading: false,
                selectedSeason: {},
                seasonMasterForm: {}
            };
        case FETCH_SEASON_MASTER_FAILURE:
        case CREATE_SEASON_MASTER_FAILURE:
        case FETCH_SINGLE_SEASON_MASTER_FAILURE:
        case UPDATE_SEASON_MASTER_FAILURE:
        case DELETE_SEASON_MASTER_FAILURE:
            return {
                ...state,
                loading: false,
                errorMessage: updatePayload
            };
        case CREATE_USER_FORM_SEASON_MASTER:
            return {
                ...state,
                loading: false,
                seasonMasterForm: {
                    ...state.seasonMasterForm,
                    [payload.key]: payload.value
                }
            };
        case SEASON_MASTER_USERFORM_RESET:
            return {
                ...state,
                selectedSeason: {},
                seasonMasterForm: {}
            };
        default:
            return state;
    }
};
